module.exports = __webpack_public_path__ + "img/Mobile-MenuPanel-BackArrow.d1980cc8.svg";